// ##### 25-04-30 Komarov
import parse from 'html-react-parser';
import uniqueId from 'lodash.uniqueid';
// ##### Komarov 2025-07-12
import React, { useEffect, useRef } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
// ##### 25-05-21 Komarov
import LocalizationNavLink from '../../../Library/Localization/LocalizationNavLink';
import { useWindowWidthAndHeight } from '../../Helpers/WindowResizeHook';

// ##### Komarov 2025-07-14
const Requests = ({ pages, title, isWhiteLabelSet, companyCipher }) => {
  const requestsRef = useRef();
  const requestsItemsRef = useRef();
  // ##### 24-09-20 Komarov
  const [innerWidth] = useWindowWidthAndHeight();
  // ##### Komarov 2025-07-12
  useEffect(() => {
    requestsItemsRef.current.style.left = `${requestsRef.current.offsetLeft}px`;
  }, [innerWidth]);

  const removeRequestsItems = () => {
    const requestsItemsclassList = requestsItemsRef.current.classList;
    if (!requestsItemsclassList.contains('DropDownMenuItemsHide')) {
      requestsItemsclassList.add('DropDownMenuItemsHide');
    }
  };

  const toggleRequestsItems = () => {
    requestsItemsRef.current.classList.toggle('DropDownMenuItemsHide');
  };

  return (
    <OutsideClickHandler onOutsideClick={removeRequestsItems}>
      <a
        ref={requestsRef}
        role="button"
        className="DropDownMenu"
        data-component="Requests"
        onClick={toggleRequestsItems}
        onKeyDown={e => {
          if (e.key === 'Enter' || e.key === ' ') {
            toggleRequestsItems();
          }
        }}
      >
        {title}
      </a>
      <div
        className="DropDownMenuItemsHide"
        data-component="DropDownMenuItems"
        ref={requestsItemsRef}
      >
        {pages.map(page => {
          return (
            // ##### 25-04-21 Komarov
            <LocalizationNavLink
              to={
                (isWhiteLabelSet &&
                  `/ref${companyCipher}/sitepages/?name=${page.name}&spid=${page.id}`) ||
                `/sitepages/?name=${page.name}&spid=${page.id}`
              }
              key={uniqueId()}
              onClick={removeRequestsItems}
            >
              {/* ##### 26-06-30 Komarov */}
              {parse(page.title?.[0]?.text ?? '')}
            </LocalizationNavLink>
          );
        })}
      </div>
    </OutsideClickHandler>
  );
};

export default Requests;
